import { useState, useEffect } from "react";
import { getUno } from "../../../../api/apis";

export const useEditarDesvinculacion = () => {
  const [motivos, setMotivos] = useState([]);
  const [cargandoMotivos, setCargandoMotivos] = useState(true);

  const traerMotivos = async () => {
    setCargandoMotivos(true);
    try {
      const resp = await getUno("listadoclasulasdespido", null, null);
      if (resp?.data?.data) {
        setMotivos(resp.data.data);
      }
    } catch (err) {
      console.error("Error al traer motivos de desvinculación:", err);
    } finally {
      setCargandoMotivos(false);
    }
  };

  useEffect(() => {
    traerMotivos();
  }, []);

  return {
    motivos,
    cargandoMotivos,
  };
};
